import React from 'react';
import {boardUrl} from "../../config/config";

const FooterLeftLinks = [
	{
		title: 'Giao diện',
		url: `${boardUrl}/misc/style`
	},
	{
		title: 'Ngôn ngữ',
		url: `${boardUrl}/misc/language`
	}
];

const FooterRightLinks = [
	{
		title: 'Liên hệ',
		url: `${boardUrl}/misc/contact`
	},
	{
		title: 'Quy định và Nội quy',
		url: `${boardUrl}/help/terms`
	},
	{
		title: 'Chính sách bảo mật',
		url: `${boardUrl}/help/privacy-policy`
	},
	{
		title: 'Trợ giúp',
		url: `${boardUrl}/help`
	},
	{
		title: 'Trang chủ',
		url: `${boardUrl}`
	},
];

const FooterLink = ({title, url}) => {
	return <a href={url} className="text-sm text-white hover:underline">{title}</a>;
}

const Footer = () => {
	return (
		<footer className="pb-[80px] lg:pb-0">
			<div className="hidden footer-inner w-auto mx-4 relative py-4 lg:block">
				<div className="footer-inner-left absolute top-0 left-0 h-[50px] w-[29px] z-30"></div>

				<div className="relative flex flex-wrap items-center justify-between px-4 z-40">
					<ul className="flex flex-wrap items-center gap-x-4">
						{FooterLeftLinks.map((item, i) => (
							<FooterLink key={i} url={item.url} title={item.title}/>
						))}
					</ul>

					<ul className="flex flex-wrap items-center gap-x-4">
						{FooterRightLinks.map((item, i) => (
							<FooterLink key={i} url={item.url} title={item.title}/>
						))}
					</ul>
				</div>

				<div className="footer-inner-right absolute top-0 right-0 h-[50px] w-[29px] z-30"></div>
			</div>

			<div className="hidden mt-6 mb-6 lg:block">
				<div className="container mx-auto px-4 text-center text-sm text-url hover:underline">
					Copyright 2024 KNV
				</div>
			</div>
		</footer>
	);
};

export default Footer;
